/** Etiquetas y permisos de menú por rol — Oficina Digital 2026 */

export const ROLE_LABELS = {
  citizen: 'Ciudadano',
  operator: 'Operador',
  reviewer: 'Revisor',
  titular: 'Titular Ejecutivo',
  signer: 'Titular Ejecutivo', // alias legacy
  field_supervisor: 'Supervisor de Cuadrillas',
  field_operator: 'Operario de Cuadrilla',
  archivist: 'Archivista Institucional',
  admin: 'Administrador General',
  superadmin: 'Superadministrador de Plataforma',
  platform_superadmin: 'Superadministrador de Plataforma',
  ventanilla_unica: 'Ventanilla Única',
  notary_public: 'Notario Público',
  notary_substitute: 'Notario Suplente',
  legal_drafter: 'Redactor Jurídico',
  notarial_assistant: 'Asistente Notarial',
  pld_compliance: 'Cumplimiento PLD',
  tax_accounting: 'Fiscal Contable Notarial',
  billing: 'Facturación Notarial',
  notarial_archive: 'Archivo Notarial',
  reception: 'Recepción Notarial',
  notarial_client: 'Cliente Notarial',
  institute_head: 'Titular del Instituto',
  citizen_services_subcounsel: 'Titular Subconsejería de Servicios',
  notaries_director: 'Titular Dirección de Notarías',
  notarial_inspection_coordinator: 'Coordinación de inspecciones',
  notarial_inspector: 'Inspector notarial',
  notarial_patent_officer: 'Operador de patentes',
  notarial_registry_officer: 'Operador de registro notarial',
  state_notarial_archivist: 'Archivo notarial estatal',
  notarial_testament_officer: 'Testamentos y apoyo notarial',
  notarial_proceeding_officer: 'Instructor de procedimiento',
  notarial_resolution_reviewer: 'Revisor jurídico de resolución',
  institute_admin: 'Administrador institucional',
  institute_readonly: 'Consulta institucional',
};

export const ROLE_BADGE_CLASSES = {
  citizen: 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-800 dark:text-emerald-300 border-emerald-300 dark:border-emerald-700',
  operator: 'bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300 border-blue-300 dark:border-blue-700',
  reviewer: 'bg-indigo-100 dark:bg-indigo-900/50 text-indigo-800 dark:text-indigo-300 border-indigo-300 dark:border-indigo-700',
  titular: 'bg-purple-100 dark:bg-purple-900/50 text-purple-800 dark:text-purple-300 border-purple-300 dark:border-purple-700',
  signer: 'bg-purple-100 dark:bg-purple-900/50 text-purple-800 dark:text-purple-300 border-purple-300 dark:border-purple-700',
  field_supervisor: 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300 border-amber-300 dark:border-amber-700',
  field_operator: 'bg-orange-100 dark:bg-orange-900/50 text-orange-800 dark:text-orange-300 border-orange-300 dark:border-orange-700',
  archivist: 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300 border-amber-300 dark:border-amber-700',
  admin: 'bg-red-100 dark:bg-red-900/50 text-red-800 dark:text-red-300 border-red-300 dark:border-red-700',
  superadmin: 'bg-gradient-to-r from-purple-100 to-indigo-100 text-indigo-900 border-indigo-400 font-bold dark:from-purple-950 dark:to-indigo-950 dark:text-indigo-200',
  platform_superadmin: 'bg-gradient-to-r from-purple-100 to-indigo-100 text-indigo-900 border-indigo-400 font-bold dark:from-purple-950 dark:to-indigo-950 dark:text-indigo-200',
  ventanilla_unica: 'bg-teal-100 dark:bg-teal-900/50 text-teal-800 dark:text-teal-300 border-teal-300 dark:border-teal-700',
  notary_public: 'bg-indigo-100 dark:bg-indigo-900/50 text-indigo-800 dark:text-indigo-300 border-indigo-300 dark:border-indigo-700',
  notary_substitute: 'bg-violet-100 dark:bg-violet-900/50 text-violet-800 dark:text-violet-300 border-violet-300 dark:border-violet-700',
  legal_drafter: 'bg-sky-100 dark:bg-sky-900/50 text-sky-800 dark:text-sky-300 border-sky-300 dark:border-sky-700',
  notarial_assistant: 'bg-cyan-100 dark:bg-cyan-900/50 text-cyan-800 dark:text-cyan-300 border-cyan-300 dark:border-cyan-700',
  pld_compliance: 'bg-purple-100 dark:bg-purple-900/50 text-purple-800 dark:text-purple-300 border-purple-300 dark:border-purple-700',
  tax_accounting: 'bg-orange-100 dark:bg-orange-900/50 text-orange-800 dark:text-orange-300 border-orange-300 dark:border-orange-700',
  billing: 'bg-lime-100 dark:bg-lime-900/50 text-lime-800 dark:text-lime-300 border-lime-300 dark:border-lime-700',
  notarial_archive: 'bg-stone-100 dark:bg-stone-900/50 text-stone-800 dark:text-stone-300 border-stone-300 dark:border-stone-700',
  reception: 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-600',
  notarial_client: 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-800 dark:text-emerald-300 border-emerald-300 dark:border-emerald-700',
  institute_head: 'bg-teal-100 dark:bg-teal-900/50 text-teal-900 dark:text-teal-200 border-teal-300 dark:border-teal-700',
  citizen_services_subcounsel: 'bg-teal-100 dark:bg-teal-900/50 text-teal-800 dark:text-teal-300 border-teal-300 dark:border-teal-700',
  notaries_director: 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-900 dark:text-emerald-200 border-emerald-400 dark:border-emerald-700',
  notarial_inspection_coordinator: 'bg-amber-100 dark:bg-amber-900/50 text-amber-900 dark:text-amber-200 border-amber-300 dark:border-amber-700',
  notarial_inspector: 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300 border-amber-300 dark:border-amber-700',
  notarial_patent_officer: 'bg-sky-100 dark:bg-sky-900/50 text-sky-800 dark:text-sky-300 border-sky-300 dark:border-sky-700',
  notarial_registry_officer: 'bg-cyan-100 dark:bg-cyan-900/50 text-cyan-800 dark:text-cyan-300 border-cyan-300 dark:border-cyan-700',
  state_notarial_archivist: 'bg-stone-100 dark:bg-stone-900/50 text-stone-800 dark:text-stone-300 border-stone-300 dark:border-stone-700',
  notarial_testament_officer: 'bg-lime-100 dark:bg-lime-900/50 text-lime-800 dark:text-lime-300 border-lime-300 dark:border-lime-700',
  notarial_proceeding_officer: 'bg-orange-100 dark:bg-orange-900/50 text-orange-800 dark:text-orange-300 border-orange-300 dark:border-orange-700',
  notarial_resolution_reviewer: 'bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300 border-blue-300 dark:border-blue-700',
  institute_admin: 'bg-slate-200 dark:bg-slate-800 text-slate-800 dark:text-slate-200 border-slate-400 dark:border-slate-600',
  institute_readonly: 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-300 dark:border-slate-600',
};

/** Roles de personal del vertical notarial (no incluye admin/titular municipal). */
export const NOTARIAL_STAFF_ROLES = new Set([
  'notary_public',
  'notary_substitute',
  'legal_drafter',
  'notarial_assistant',
  'pld_compliance',
  'tax_accounting',
  'billing',
  'notarial_archive',
  'reception',
]);

export function isNotarialStaffRole(role) {
  return NOTARIAL_STAFF_ROLES.has(role);
}

/**
 * Shell de producto notarial (personal o admin/titular de membresía notarial).
 * Ciudadano, instituto y superadmin de plataforma quedan fuera.
 */
export function isNotarialProductShell(role, entitlements = {}, features = {}) {
  if (!role) return false;
  if (
    role === 'citizen'
    || role === 'superadmin'
    || role === 'platform_superadmin'
    || role === 'notarial_client'
  ) {
    return false;
  }
  if (isNotarialStaffRole(role)) return true;
  const vertical = String(entitlements?.vertical || '').toLowerCase();
  const tmpl = String(entitlements?.membership_template || '').toLowerCase();
  const notarialTenant = vertical === 'notarial'
    || tmpl.includes('notaria')
    || features?.notarial_operations === true;
  return notarialTenant && (role === 'admin' || role === 'titular');
}

/** Rutas exclusivas del escritorio notarial. */
export function isNotarialMenuPath(path) {
  if (!path) return false;
  return path === '/backoffice/notaria'
    || path.startsWith('/backoffice/notaria/')
    || path === '/ayuda/glosario';
}

export function getRoleLabel(role) {
  return ROLE_LABELS[role] || role || 'Usuario';
}

export function getRoleBadgeClass(role) {
  return ROLE_BADGE_CLASSES[role] || 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300';
}

/** Paths permitidos por rol (además de admin que ve todo). */
export const ROLE_MENU_PATHS = {
  operator: [
    '/backoffice/escritorio',
    '/backoffice/dashboard',
    '/backoffice/despacho',
    '/backoffice/instrucciones',
    '/backoffice/correspondencia',
    '/backoffice/oficios',
    '/backoffice/oficios-recibidos',
    '/backoffice/inbox',
    '/backoffice/documents',
    '/backoffice/expedientes',
    '/backoffice/cases',
    '/backoffice/plantillas',
    '/backoffice/turnados',
    '/backoffice/cuadrillas',
    '/backoffice/cuadrillas/movil',
    '/backoffice/reportes',
    '/backoffice/libro',
    '/backoffice/valijas',
    '/backoffice/mi-efirma',
    '/backoffice/seguridad-cuenta',
  ],
  reviewer: [
    '/backoffice/escritorio',
    '/backoffice/dashboard',
    '/backoffice/despacho',
    '/backoffice/instrucciones',
    '/backoffice/oficios',
    '/backoffice/oficios-recibidos',
    '/backoffice/inbox',
    '/backoffice/flujos',
    '/backoffice/turnados',
    '/backoffice/cases',
    '/backoffice/documents',
    '/backoffice/expedientes',
    '/backoffice/correspondencia',
    '/backoffice/firmas',
    '/backoffice/mi-efirma',
    '/backoffice/seguridad-cuenta',
    '/backoffice/mifiel',
    '/backoffice/reportes',
  ],
  titular: [
    '/backoffice/despacho',
    '/backoffice/escritorio',
    '/backoffice/instrucciones',
    '/backoffice/semaforo-cumplimiento',
    '/backoffice/acuerdos-gabinete',
    '/backoffice/cabildo',
    '/backoffice/analitica-territorial',
    '/backoffice/cuadrillas',
    '/backoffice/dashboard',
    '/backoffice/oficios',
    '/backoffice/oficios-recibidos',
    '/backoffice/correspondencia',
    '/backoffice/libro',
    '/backoffice/valijas',
    '/backoffice/firmas',
    '/backoffice/mi-efirma',
    '/backoffice/seguridad-cuenta',
    '/backoffice/mifiel',
    '/backoffice/turnados',
    '/backoffice/documents',
    '/backoffice/expedientes',
    '/backoffice/reportes',
    '/backoffice/analytics',
    '/backoffice/cases',
  ],
  signer: [
    '/backoffice/despacho',
    '/backoffice/escritorio',
    '/backoffice/firmas',
    '/backoffice/mi-efirma',
    '/backoffice/seguridad-cuenta',
    '/backoffice/mifiel',
    '/backoffice/oficios',
    '/backoffice/oficios-recibidos',
    '/backoffice/documents',
    '/backoffice/cases',
  ],
  field_supervisor: [
    '/backoffice/cuadrillas',
    '/backoffice/cuadrillas/movil',
    '/backoffice/analitica-territorial',
    '/backoffice/escritorio',
    '/backoffice/cases',
    '/backoffice/instrucciones',
    '/backoffice/reportes',
  ],
  field_operator: [
    '/backoffice/cuadrillas/movil',
    '/backoffice/escritorio',
  ],
  archivist: [
    '/backoffice/archivo',
    '/backoffice/clasificacion-archivistica',
    '/backoffice/expedientes',
    '/backoffice/escritorio',
    '/backoffice/libro',
    '/backoffice/valijas',
    '/backoffice/documents',
    '/backoffice/reportes',
    '/backoffice/dashboard',
  ],
  ventanilla_unica: [
    '/backoffice/ventanilla',
  ],
  notary_public: [
    '/backoffice/notaria',
    '/ayuda/glosario',
    '/backoffice/seguridad-cuenta',
  ],
  notary_substitute: [
    '/backoffice/notaria',
    '/ayuda/glosario',
    '/backoffice/seguridad-cuenta',
  ],
  legal_drafter: [
    '/backoffice/notaria',
    '/ayuda/glosario',
    '/backoffice/seguridad-cuenta',
  ],
  notarial_assistant: [
    '/backoffice/notaria',
    '/ayuda/glosario',
    '/backoffice/seguridad-cuenta',
  ],
  pld_compliance: [
    '/backoffice/notaria',
    '/ayuda/glosario',
    '/backoffice/seguridad-cuenta',
  ],
  tax_accounting: [
    '/backoffice/notaria',
    '/ayuda/glosario',
    '/backoffice/seguridad-cuenta',
  ],
  billing: [
    '/backoffice/notaria',
    '/backoffice/seguridad-cuenta',
  ],
  notarial_archive: [
    '/backoffice/notaria',
    '/ayuda/glosario',
    '/backoffice/archivo',
    '/backoffice/seguridad-cuenta',
  ],
  reception: [
    '/backoffice/notaria',
    '/ayuda/glosario',
    '/backoffice/seguridad-cuenta',
  ],
  notarial_client: [
    '/portal-notario',
  ],
  institute_head: ['/instituto'],
  citizen_services_subcounsel: ['/instituto'],
  notaries_director: ['/instituto'],
  notarial_inspection_coordinator: ['/instituto'],
  notarial_inspector: ['/instituto'],
  notarial_patent_officer: ['/instituto'],
  notarial_registry_officer: ['/instituto'],
  state_notarial_archivist: ['/instituto'],
  notarial_testament_officer: ['/instituto'],
  notarial_proceeding_officer: ['/instituto'],
  notarial_resolution_reviewer: ['/instituto'],
  institute_admin: ['/instituto'],
  institute_readonly: ['/instituto'],
  admin: null, // Acceso total a todas las rutas
};

export function roleCanAccessPath(role, path) {
  if (!role || !path) return false;
  // Portal Instituto: roles del vertical regulatorio
  if (path.startsWith('/instituto')) {
    return (
      role.startsWith('institute_')
      || role === 'citizen_services_subcounsel'
      || role === 'notaries_director'
      || role === 'state_notarial_archivist'
      || [
        'notarial_inspection_coordinator',
        'notarial_inspector',
        'notarial_patent_officer',
        'notarial_registry_officer',
        'notarial_testament_officer',
        'notarial_proceeding_officer',
        'notarial_resolution_reviewer',
      ].includes(role)
    );
  }
  if (
    path === '/backoffice/notaria/expedientes-publicos'
    || path.startsWith('/backoffice/notaria/expedientes-publicos/')
  ) {
    return false;
  }
  if (
    isNotarialStaffRole(role)
    && ['/backoffice/escritorio', '/backoffice/firmas', '/backoffice/documents', '/backoffice/plantillas']
      .some((item) => path === item || path.startsWith(`${item}/`))
  ) {
    return false;
  }
  // Rutas notariales: personal notarial; admin/titular se validan además por feature en StaffRoute
  if (isNotarialMenuPath(path)) {
    return isNotarialStaffRole(role) || role === 'admin' || role === 'titular';
  }
  if (role === 'admin' || role === 'superadmin' || role === 'platform_superadmin') return path.startsWith('/backoffice');
  if (role === 'citizen') return path.startsWith('/citizen') || path.startsWith('/verify');
  if (role === 'notarial_client') return path.startsWith('/portal-notario');
  const allowed = ROLE_MENU_PATHS[role];
  if (!allowed) return false;
  return allowed.some((p) => path === p || path.startsWith(p + '/'));
}

/** Destino post-login por rol */
export function getDefaultHomeForRole(role) {
  switch (role) {
    case 'citizen':
      return '/citizen/dashboard';
    case 'superadmin':
    case 'platform_superadmin':
      return '/backoffice/plataforma';
    case 'ventanilla_unica':
      return '/backoffice/ventanilla';
    case 'archivist':
      return '/backoffice/archivo';
    case 'titular':
    case 'signer':
      return '/backoffice/despacho';
    case 'field_supervisor':
      return '/backoffice/cuadrillas';
    case 'field_operator':
      return '/backoffice/cuadrillas/movil';
    case 'notarial_client':
      return '/portal-notario';
    case 'institute_head':
    case 'citizen_services_subcounsel':
    case 'notaries_director':
    case 'notarial_inspection_coordinator':
    case 'notarial_inspector':
    case 'notarial_patent_officer':
    case 'notarial_registry_officer':
    case 'state_notarial_archivist':
    case 'notarial_testament_officer':
    case 'notarial_proceeding_officer':
    case 'notarial_resolution_reviewer':
    case 'institute_admin':
    case 'institute_readonly':
      return '/instituto/escritorio';
    case 'notary_public':
    case 'notary_substitute':
    case 'legal_drafter':
    case 'notarial_assistant':
    case 'pld_compliance':
    case 'tax_accounting':
    case 'billing':
    case 'notarial_archive':
    case 'reception':
      return '/backoffice/notaria';
    case 'admin':
    case 'operator':
    case 'reviewer':
    default:
      return '/backoffice/escritorio';
  }
}
